export { default as studentDomain } from "./Student.domain";
